// Touching `config` runs its required-var assertions as a side effect.
// This step exists so bootstrap fails *before* any plugin init when a deploy
// is misconfigured — the trace blames a missing env var, not a downstream null.

import { config } from '@core/config'
import { logger } from '@core/logging/logger'

export const initEnv = (): void => {
  logger.debug('env initialised', { appEnv: config.appEnv, logLevel: config.logLevel })
}
